export const type = {
  CUSTOM: "custom",
  DOMAIN: "domain",
  HOSTING: "hosting",
  SUBSCRIPTION: "subscription",
  TASK_CREDIT: "taskCredit"
};
